export { default } from './VerticalSlider';
